export const allowedFilterParams = [
  'search',
  'id',
  'isPublished',
  'category_id',
  'group_id',
  'make',
  'model',
  'price_le',
  'price_ge',
  'year_le',
  'year_ge',
  'meta_km_ge',
  'meta_km_le',
  'meta_hours_ge',
  'meta_hours_le',
  'meta_hk_ge',
  'meta_hk_le',
  'meta_kg_ge',
  'meta_kg_le',
  'export',
  'active_auction',
  'has_auction',
  'zipcode',
  'municipality',
  'county',
  'country',
  'customer_v3_id',
  'customer_v3_type',
  'auctions',
  'is_auction',
];
